import { useAppSelector } from '@/store/hooks';
import { getWorkingProjectUuid } from '@/store/slices/project/selectors';
import { getActiveChannel } from '@/store/slices/user/selectors';
import Text from '@ui/text/text/text';
import Container from '@ui/container/container';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import { getUserTimezone } from '@ui/calendar/utils';
import TooltipPortal from '@ui/tooltip-portal/tooltip-portal';
import useGetActivityLog from './use-get-activity-log';
import { getMostRecentActivityLogType, getMostRecentActivityLogUpdate } from '@/store/slices/project/selectors';
import { IActivityTypes } from '@/types/activity-log.types';
import { TooltipPortalContentDirection } from '@ui/tooltip-portal/tooltip-portal-types';

const ActivityIndicator = () => {
  const workingProjectUuid = useAppSelector(getWorkingProjectUuid);
  const userActiveChannel = useAppSelector(getActiveChannel);
  const mostRecentActivityLogUpdate = useAppSelector(getMostRecentActivityLogUpdate);
  const mostRecentActivityLogType = useAppSelector(getMostRecentActivityLogType);

  useGetActivityLog(userActiveChannel, workingProjectUuid);

  const formattedDate = new Date(mostRecentActivityLogUpdate || 0).toLocaleDateString([], {
    month: 'short',
    day: 'numeric',
    timeZone: getUserTimezone(),
  });

  const formattedTime = new Date(mostRecentActivityLogUpdate || 0).toLocaleTimeString([], {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZone: getUserTimezone(),
  });

  const mostRecentUpdateIsPublish = mostRecentActivityLogType === IActivityTypes.published_events;

  if (!mostRecentActivityLogUpdate) return <></>;

  return (
    <Container background="none" className="flex ai-center margin-l-8">
      <TooltipPortal
        contentDirection={TooltipPortalContentDirection.CENTER}
        tooltipContent={
          <Text color="var(--gray-true-dark-100)" className="P2">
            Last {mostRecentUpdateIsPublish ? 'published' : 'updated'}
          </Text>
        }
        childrenWrapperClass="flex ai-center jc-center"
        styles={{ padding: '8px', backgroundColor: 'var(--gray-true-dark-700)' }}
        keepOpenOnContentHover={false}
      >
        <Icon color="var(--gray-600)" size={16} name={mostRecentUpdateIsPublish ? ICONS.GLOBE_CLOCK : ICONS.CLOCK_2} />
      </TooltipPortal>
      <Text className="C1 margin-l-4" width="fit-content" whiteSpace="nowrap" color="var(--gray-600)">
        {formattedDate} • {formattedTime}
      </Text>
    </Container>
  );
};

export default ActivityIndicator;
